<template>
  <div>
    <b-btn
      id="responsavelBtn"
      v-b-tooltip.hover
      title="Responsáveis Internos"
      pill
      variant="none"
      style="padding:0.5rem; float:right"
      class="btn-outline-primary"
      @click="abrirInfo()"
    >
      <feather-icon icon="UsersIcon" />
    </b-btn>

    <div id="popoverContainer">
      <b-popover
        :id="'responsavel'"
        ref="responsavel"
        placement="auto"
        target="responsavelBtn"
        container="popoverContainer"
        triggers="manual"
        :show.sync="mostrarPopover"
      >
        <div slot="title">
          <span
            class="text-center"
            style="vertical-align: sub"
          >Responsáveis</span>

          <b-button
            variant="none"
            class="close "
            @click="cancelar"
          >
            <span aria-hidden="true">&times;</span>
          </b-button>
        </div>
        <template v-for="val in info">
          <div
            v-for="(item, $index) in val.usuariosResponsaveis"
            :key="$index"
          >
            <b-row>
              <b-col cols="12">
                <strong>Departamento: </strong>{{ `${val.departamento.nome}` }}
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <strong>Responsável: </strong>{{ `${item.usuario.nomeCompleto}` }}
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <strong>E-mail: </strong>{{ `${item.usuario.email}` }}
              </b-col>
            </b-row>
            <hr>
          </div>
        </template>
      </b-popover>
    </div>

  </div>
</template>

<style lang="scss">
@import "@core/scss/base/components/visualizar-responsavel.scss"
</style>

<script>
import { mapGetters } from 'vuex'
import apiDepartamentos from '@/app-modulo/comuns/departamentos/shared/services/api'
import { getUserData } from '@/auth/utils'

export default {
  name: 'VisualizarResponsaveis',
  data() {
    return {
      mostrarPopover: false,
      info: [],
    }
  },
  computed: {
    ...mapGetters('empresaExGlobal', ['empresa', 'escolherEmpresa']),
  },
  methods: {
    cancelar() {
      this.mostrarPopover = false
      this.$emit('cancel')
    },
    abrirInfo() {
      this.mostrarPopover = true
      this.getResponsaveisInfo()
    },
    getResponsaveisInfo() {
      apiDepartamentos.getResponsaveis(getUserData().id, this.empresa.id)
        .then(payload => {
          this.info = payload.data
        })
        .catch(err => {
          throw err
        })
    },
  },
}
</script>
